import { FunctionComponent, useEffect, useState } from "react"
import { a, useTrail } from 'react-spring'
import '../../App.scss';

interface Props {
  activeScene: number
  width: number
  breakpoint: number
}

const GameDev: FunctionComponent<Props> = (props) => {
  const { width, breakpoint } = props

  const [open, set] = useState(false) 
  const items = [0, 1, 2, 3, 4]
  const trail = useTrail(items.length, {
    config: { mass: 10, tension: 1000, friction: 200 },
    opacity: open ? 1 : 0,
    x: open ? 0 : 80,
    minus_x: open ? 0 : -80
  })

  const handleOnClick = (link: string) => {
    window.open(link);
  }

  useEffect(() => {
    set(props.activeScene === 2)
  }, [props.activeScene])

  return(
    <div className="subject-canvas game-dev">
      <video className="video" autoPlay loop muted>
        <source src={process.env.PUBLIC_URL + '/BG_gameplay.mp4'} type='video/mp4' />
      </video>
      <div className="container-gd">
        <div className="card black-bg">
          <a.div className="text-container" style={{ opacity: trail[4].opacity }}>
            <div className="title-text-container">
              <a.div className="title-text" style={{ x: trail[3].minus_x, opacity: trail[3].opacity }}>Games</a.div>
            </div>
            <div className="about-list">
              <a.div className="about-list-item" style={{ x: trail[1].x, opacity: trail[1].opacity }}>
                <div className="about-text clickable" onClick={() => handleOnClick("https://guigs10mil.itch.io/eddie-the-mole")}>Eddie: the Mole - <em>2D Platformer</em></div>
                <div className="about-text-small justify">With the design philosophy that one action can solve multiple problems at once, the player can jump, dig, glide, and attack enemies while only using the keyboard's arrow keys.</div>
              </a.div>
              <a.div className="about-list-item" style={{ x: trail[2].x, opacity: trail[2].opacity }}>
                <div className="about-text">Asymmetric Climb - <em>Asymmetric VR Experience</em></div>
                <div className="about-text-small justify">This is a asymmetric local multiplayer VR game. This setup creates a unique interaction that is explored in this game through two different small challenges.</div>
              </a.div>
              <a.div className="about-list-item" style={{ x: trail[3].x, opacity: trail[3].opacity }}>
                <div className="about-text">Other Games</div>
                <div className="about-text-small justify">These two and more games made by me can be played and downloaded from my Itch.io profile page: <a style={{ color: "inherit" }} rel="noreferrer" target="_blank" href="https://guigs10mil.itch.io">guigs10mil.itch.io</a>.</div>
              </a.div>
            </div>
          </a.div>
        </div>
        <div style={{ height: "2vh", maxHeight: "10rem", minHeight: "1rem" }} />
        <div className="card black-bg">
          <a.div className="text-container" style={{ opacity: trail[4].opacity }}>
            {width <= breakpoint
              ? (
                <div className="title-text-container">
                  <a.div className="title-text" style={{ x: trail[3].x, opacity: trail[3].opacity }}>Education</a.div>
                </div>
              ) : null
            }
            <div className="about-list">
              <a.div className="about-list-item" style={{ x: trail[1].minus_x, opacity: trail[1].opacity }}>
                <div className="about-text">Game Design and Development - <em>Insper</em></div>
                <div className="about-text-small justify">Focused on what to do instead of how, this class taught me how to create engaging games using Narrative, Flow, and Gameplay fundamentals.</div>
              </a.div>
              <a.div className="about-list-item" style={{ x: trail[2].minus_x, opacity: trail[2].opacity }}>
                <div className="about-text">Game Development - <em>UC Berkeley</em></div>
                <div className="about-text-small justify">Game Development course organized and teached by UC Berkeley's students. Enrolled during UC Berkeley Exchange Program.</div>
              </a.div>
              <a.div className="about-list-item" style={{ x: trail[3].minus_x, opacity: trail[3].opacity }}>
                <div className="about-text">Game Design and Documentation - <em>Michigan State University</em></div>
                <div className="about-text-small justify">During this course I've learned how games are made in the industry, from the idealization to the testing stage, and writing Game Design documentation along the way. Introduction to Game Design online course available on Coursera.</div>
              </a.div>
            </div>
            {width > breakpoint
              ? (
                <div className="title-text-container">
                  <a.div className="title-text" style={{ x: trail[3].x, opacity: trail[3].opacity }}>Education</a.div>
                </div>
              ) : null
            }
          </a.div>
        </div>
        {width < breakpoint
          ? <div style={{ minHeight: "7rem" }} />
          : null
        }
      </div>
    </div>
  )
}

export { GameDev }